import { FC } from "react";
import { Grid, Heading } from '@chakra-ui/react';

type Props = {
  heading: string;
  subHeading: string;
  style?: any;
}

export const HeaderStacked: FC<Props> = ({ heading, subHeading }) => (
  <Grid
    as="header"
    gridTemplateColumns="1fr"
    gap="10px"
    textAlign="center"
  >
    <Heading as="h1" size="xl">{heading}</Heading>
    <Heading as="h2" size="md" variant="alt">{subHeading}</Heading>
  </Grid>
);
